export default function Footer() {
return (
<div className="footer">
All Rights Reserved © 2025.
 {/* Icons by Freepik - Flaticon */}
</div>
);
}
